"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "calendar-footer"
};
const _hoisted_2 = {
    key: 1,
    class: "calendar-footer"
};
const _hoisted_3 = { class: "left" };
const _hoisted_4 = { class: "right" };
const vue_router_1 = require("vue-router");
const CalendarFooterItems_vue_1 = __importDefault(require("./CalendarFooterItems.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'CalendarFooter',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        return (_ctx, _cache) => {
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                ((0, vue_2.unref)(route).name === 'reservations_calendar_view')
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("footer", _hoisted_1, [
                        (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                            "circle-class": "bg-online",
                            text: _ctx.$trans('online_reservation', 'Online reservation', 'fullcalendar_footer')
                        }, null, 8, ["text"]),
                        (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                            "circle-class": "bg-yellow",
                            text: _ctx.$trans('service_reservation', 'Service Reservation', 'fullcalendar_footer')
                        }, null, 8, ["text"]),
                        (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                            "circle-class": "bg-bhp",
                            text: _ctx.$trans('bhp_reservation', 'BHP', 'fullcalendar_footer')
                        }, null, 8, ["text"]),
                        (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                            "circle-class": "bg-marso",
                            text: _ctx.$trans('marso_reservation', 'Marso', 'fullcalendar_footer')
                        }, null, 8, ["text"]),
                        (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                            "circle-class": "bg-marso-flotta",
                            text: _ctx.$trans('marso_flotta_reservation', 'Marso Flotta', 'fullcalendar_footer')
                        }, null, 8, ["text"]),
                        (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                            icon: true,
                            text: _ctx.$trans('open_reservation', 'Open reservation', 'fullcalendar_footer')
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(_component_font_awesome_icon, {
                                    class: "fontawsome-icon text-orange",
                                    icon: "fa-solid fa-circle-exclamation"
                                })
                            ]),
                            _: 1
                        }, 8, ["text"])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(route).name === 'reservations_list_view')
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("footer", _hoisted_2, [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                                "circle-class": "bg-online",
                                text: _ctx.$trans('online_reservation', 'Online reservation', 'appointment_list_footer')
                            }, null, 8, ["text"]),
                            (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                                "circle-class": "bg-yellow",
                                text: _ctx.$trans('service_reservation', 'Service Reservation', 'appointment_list_footer')
                            }, null, 8, ["text"]),
                            (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                                "circle-class": "bg-bhp",
                                text: _ctx.$trans('bhp_reservation', 'BHP', 'appointment_list_footer')
                            }, null, 8, ["text"]),
                            (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                                "circle-class": "bg-marso",
                                text: _ctx.$trans('marso_reservation', 'Marso', 'appointment_list_footer')
                            }, null, 8, ["text"]),
                            (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                                "circle-class": "bg-marso-flotta",
                                text: _ctx.$trans('marso_flotta_reservation', 'Marso Flotta', 'appointment_list_footer')
                            }, null, 8, ["text"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                                icon: true,
                                text: _ctx.$trans('open_list', 'Open', 'appointment_list_footer')
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_font_awesome_icon, {
                                        class: "fontawsome-icon text-orange",
                                        icon: "fa-solid fa-circle-exclamation"
                                    })
                                ]),
                                _: 1
                            }, 8, ["text"]),
                            (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                                icon: true,
                                text: _ctx.$trans('approved', 'Approved', 'appointment_list_footer')
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_font_awesome_icon, {
                                        class: "fontawsome-icon text-bhp",
                                        icon: ['fas', 'circle-check']
                                    })
                                ]),
                                _: 1
                            }, 8, ["text"]),
                            (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                                icon: true,
                                text: _ctx.$trans('deleted', 'Deleted', 'appointment_list_footer')
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_font_awesome_icon, {
                                        class: "fontawsome-icon text-marso",
                                        icon: ['fas', 'circle-xmark']
                                    })
                                ]),
                                _: 1
                            }, 8, ["text"]),
                            (0, vue_2.createVNode)(CalendarFooterItems_vue_1.default, {
                                "circle-class": "bg-closed",
                                icon: true,
                                text: _ctx.$trans('closed', 'Closed', 'appointment_list_footer')
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_font_awesome_icon, {
                                        class: "fontawsome-icon text-white scale-50",
                                        icon: ['fas', 'lock']
                                    })
                                ]),
                                _: 1
                            }, 8, ["text"])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
